import { FC } from "react";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { NewCountry } from "./newCountry";
import { CountriesRoutes } from "./routes";
import { RequireCreateCountry } from "../../auth/RequireCreateCountry";

type Props = {};

export const Countries: FC<Props> = () => {
  return (
    <Box
      display="flex"
      position="absolute"
      top={0}
      right={0}
      bottom={0}
      left={0}
      padding={2}
    >
      <CountriesRoutes />
      <Routes>
        <Route
          path="new"
          element={
            <RequireCreateCountry>
              <NewCountry />
            </RequireCreateCountry>
          }
        />
      </Routes>
    </Box>
  );
};
